import { Stack } from '@mantine/core';

import { useResponseProjectDetailContext } from '../../../../context/responseProjectDetailContext';
import { SummaryItem } from './components/SummaryItem';

export function Summary() {
  const { blocks } = useResponseProjectDetailContext();

  return (
    <Stack spacing="01">
      {blocks.map(block => (
        <SummaryItem key={block.id} block={block} />
      ))}
    </Stack>
  );
}
